module.exports = __webpack_public_path__ + "img/feedback_wrong.5236b119.gif";